import React, { MouseEvent, useState } from "react";
import {
  Card,
  Group,
  Stack,
  Text,
  Tooltip,
  Divider,
  CSSProperties,
  Collapse,
} from "@mantine/core";
import { TripResponse } from "types/trip.types";
import { ActionFunc } from "./helper";

interface UnassignedTripsCardProps {
  trips: TripResponse[];
  currentTripId?: number;
  expanded?: boolean; // Add optional expanded prop
  onClick?: () => void; // Add optional onClick prop
  onAction?: ActionFunc;

  adminMode?: boolean;
}

export function UnassignedTripsCard({
  trips,
  currentTripId,
  expanded,
  onClick,
  onAction,
  adminMode,
}: UnassignedTripsCardProps) {
  // const [expanded, setExpanded] = useState(current);

  const onTripClick = (e: MouseEvent, tripId: number) => {
    e.stopPropagation();
    onAction &&
      onAction("set-unassigned-tripId", {
        tripId,
      });
  };
  const handleClick = () => {
    if (currentTripId && onAction) {
      onAction("set-unassigned-tripId", {
        tripId: undefined,
      });
    }
    onClick && onClick();
  };

  const cardStyle: CSSProperties = { cursor: "pointer", role: "button" };
  return (
    <Card
      shadow="sm"
      padding="md"
      radius="md"
      withBorder
      onClick={handleClick}
      style={cardStyle}
    >
      <Stack gap="xs">
        <Group justify="space-between" align="start" wrap="nowrap">
          <Group align="center" gap="xs">
            <Text fw={600}>Unassigned Trips</Text>
          </Group>
        </Group>
        {/* Only show details if expanded */}
        <Collapse in={expanded ?? false}>
          <Stack gap="xs">
            <Divider />
            {Boolean(trips?.length) && (
              <>
                <Group gap="xs">
                  {trips?.map((trip) => (
                    <Tooltip label={trip.tripId} withArrow>
                      <Text
                        size="xs"
                        m={0}
                        p={0}
                        c={
                          !currentTripId
                            ? undefined
                            : currentTripId == trip.tripId
                            ? "white"
                            : "dimmed"
                        }
                        onClick={(e) => onTripClick(e, trip.tripId)}
                      >
                        {trip.externalId}
                      </Text>
                    </Tooltip>
                  ))}
                </Group>
                <Divider />
              </>
            )}
          </Stack>
        </Collapse>
      </Stack>
    </Card>
  );
}
